<script>

import {defineComponent} from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import {BrandsPath, GravyPath, OpsPath, PackagingPath} from "@/path";
import axios from "axios";
import Swal from "sweetalert2";
import packagin_items from './packaging_items.vue';

export default defineComponent({
  props : ['selected_item'],
  computed: {
    PackagingPath() {
      return PackagingPath
    },
    BrandsPath() {
      return BrandsPath
    },
    GravyPath() {
      return GravyPath
    }
  },
  components: {SelectWithSearch,packagin_items},
  data(){
    return {
      form : {
        item_id : this.selected_item.id,
        ops : [],
        qty : 1
      },
      packaging : [],
      fields : ["packaging","attached_to_base","brands"],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      filter : [],
      selected_option : null,
      current_page : 1,
      ops : [],
      selectedGravyItem : null
    }
  },
  watch : {
    current_page(){
      this.getItemPackaging();
    }
  },
  mounted() {
    this.getItemPackaging();
    this.getOps();
  },
  methods : {
    async getOps(){
      try {
        let res = await axios.get(this.baseUrl  + OpsPath.GETOPS,{
          params : {
            item_id: this.selected_item.id,
            no_pagination : true
          }
        });
        if(res.data.status){
          this.ops = res.data.data;
          this.form.ops.push({            
            packaging_id : null,
            brand_ids : [],            
          });
        }
      }catch (e) {
        console.log(e);
      }
    },
    async openGravyItems(v){
      this.selectedGravyItem = v;
      this.$bvModal.show('open_gravy_items_p');
    },
    async saveGravyAttach(){
      try {
        let res = await axios.post(this.baseUrl + PackagingPath.ATTACH_PACKAGING,this.form);
        if(res.data.status){
          this.getItemPackaging();
          Swal.fire("success",'','success');
        }
      }catch (e){
        console.log(e);
      }
    },
    async deletePackagingItem(v){
      try{
        let res = await axios.delete(this.baseUrl + PackagingPath.DELETE_PACKAGING_ITEMS,{
          params : {
            id : v.id
          }
        });
        if(res.data.status){
          Swal.fire("success",'','success');
          this.getItemPackaging();
        }
      }catch (e){
        console.log(e);
      }
    },
    async savePackagingAttach(){
      try {
        let res = await axios.post(this.baseUrl + PackagingPath.ATTACH_PACKAGING,this.form);
        if(res.data.status){
          Swal.fire("Added Successfully");
          this.getItemPackaging();
        }
      }catch (e){
        console.log(e);
      }
    },
    async getItemPackaging(){
      try {
        let res = await axios.get(this.baseUrl + PackagingPath.GET_PACKAGING_ITEMS_COMBINED,{
          params : {
            'item_id' : this.selected_item.id,
            page : this.current_page
          }
        });
        if(res.data.status){
          this.packaging = res.data.data;
        }
      }catch (e){
        console.log(e);
      }
    }
  }
})
</script>

<template>
  <div>
    <b-row>
      <b-col sm="4">
        <label>Packaging</label>
        <select-with-search :search_api="PackagingPath.SEARCH_PACKAGING" :send_null="true" track_by="id" display="name" @selectedOption="((v) => form.packaging_id = v)"></select-with-search>
      </b-col>
      <b-col sm="4">
        <label>Qty</label>
        <b-form-input v-model="form.qty" value="1" type="number"></b-form-input>
      </b-col>
      <b-col sm="4">
        <label>Brand</label>
        <select-with-search :full_object="true" :search_api="BrandsPath.BRAND_SEARCH" :multi_select="true" :send_null="true" track_by="id" display="label" @selectedOption="((v) => form.brand_ids = v.map(m => m.id))"></select-with-search>
      </b-col>
    </b-row>
    <!-- <template v-if="ops.length > 0">
      <hr style="margin-top: 50px;" />
      <b-row class="mb-2">
        <b-col sm="3">       
          <label>Modifiers</label>   
          <select-with-search :search_without_api="true" :optionsData="ops" :send_null="true" track_by="id" display="title" :full_object="true" @selectedOption="((v) => selected_option = v)"></select-with-search>
        </b-col>
        <b-col sm="3">
          <label>Packaging</label>
          <select-with-search :search_api="PackagingPath.SEARCH_PACKAGING" :send_null="true" track_by="id" display="name" @selectedOption="((v) => form.ops[0].packaging_id = v)"></select-with-search>
        </b-col>
        <b-col sm="3">
          <label>Qty</label>
          <b-form-input v-model="form.ops[0].qty" :value="1" type="number"></b-form-input>
        </b-col>
        <b-col sm="3">
          <label>Brand</label>
          <select-with-search :full_object="true" :search_api="BrandsPath.BRAND_SEARCH" :multi_select="true" :send_null="true" track_by="id" display="label" @selectedOption="((v) => form.ops[0].brand_ids = v.map(m => m.id))"></select-with-search>
        </b-col>
      </b-row>
      <hr style="margin-bottom: 10px;" />
    </template> -->
    <b-row>
      <b-col>
        <b-button variant="success" class="mt-3" @click="savePackagingAttach">Save</b-button>
      </b-col>
    </b-row>
    <b-modal id="open_gravy_items_p" size="lg">
      <packagin_items :gravies="selectedGravyItem?.gravy_items" :mainitem="selected_item.title" :maingravy="selectedGravyItem"></packagin_items>
    </b-modal>
    <div>
      <div class="table-responsive mb-0">
        <b-table
            :key="packaging.key"
            :items="packaging.data"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :current-page="current_page"
        >
          <template v-slot:cell(packaging)="row">
            <a style="cursor: pointer; color: blue;" @click="openGravyItems(row.item)">{{row.item.name}}</a>
          </template>
          <!-- <template v-slot:cell(modifiers_attached)="row">
            {{ [...new Set(row.item?.gravy_items.filter(f => f.op_id != null && f.option != null).map((f) => f.option.name))].length }}
          </template> -->
          <template v-slot:cell(brands)="row">
            {{ [...new Set(row.item?.gravy_items.map((f) => f.brand?.name))].join(", ") }}
          </template>
          <template v-slot:cell(attached_to_base)="row">
            {{ row.item?.gravy_items.filter((f) => f.op_id == null).length }}
          </template>

<!--           
          <template v-slot:cell(modifier)="row">
            {{row.item.option != null ? row.item.option.title : ''}}
          </template>
          <template v-slot:cell(brand)="row">
            {{row.item.brand != null ? row.item.brand.name : ''}}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button @click="deletePackagingItem(row.item)" variant="danger" size="sm">
              <i class="fa fa-trash"></i>
            </b-button>
          </template> -->
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination :key="packaging.key" v-model="current_page" :total-rows="packaging.total" :per-page="packaging.per_page"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>